/*
activitytracker.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/activitytracker.service',[
    'lodash',
    '../module',
    './login.service'
], function (_, module) {
    'use strict';

    module.service('activityTrackerService', ['$window', 'loginService', function ($window, loginService) {
        var LAST_ACTIVITY_TIME_KEY = 'lastActiveTime';

        var now = function () {
            return new Date().getTime();
        };

        var invalidate = function () {
            localStorage.removeItem(LAST_ACTIVITY_TIME_KEY);
        };

        var registerActivity = _.throttle(function () {
            localStorage.setItem(LAST_ACTIVITY_TIME_KEY, now());
        }, 10000);

        var hasPermissibleInactiveTimeLapsed = function () {
            var lastActivityTime = parseInt(localStorage.getItem(LAST_ACTIVITY_TIME_KEY) || 0);
            return lastActivityTime + loginService.getMaxInactiveTime() < now();
        };

        var validateLastActivityTime = function () {
            var isActive = true;
            if (hasPermissibleInactiveTimeLapsed()) {
                isActive = false;
                invalidate();
                loginService.invalidate();
                $window.top.location = '/login?message=440';
            }
            return isActive;
        };

        this.registerActivity = registerActivity;
        this.validateLastActivityTime = validateLastActivityTime;

    }]);

});
